import React from "react";
import { useSelector } from "react-redux";

const ProductEcommerce = ({
  productEcom,
  storeLoc,
  onEcoChangeText,
  addRowEcom,
  removeRowEcom,
  productDetail,
  deletedEcom,
  approval_status,
  next_step_nik_detail,
}) => {
  let { userInfo } = useSelector((state) => state.auth);
  return (
    <div>
      {productEcom &&
        productEcom.length > 0 &&
        productEcom?.map((item, index) => (
          <div className="row" key={index}>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="store">Store</label>
                <select
                  disabled={
                    approval_status &&
                    approval_status != "NOT SUBMITTED" &&
                    approval_status != "COMPLETED" &&
                    approval_status != "REJECTED" &&
                    (approval_status != "ONREVISED" ||
                      next_step_nik_detail != userInfo.nik)
                  }
                  id="id_store"
                  name="id_store"
                  className="form-control mr-2"
                  onChange={(e) => onEcoChangeText(e, index)}
                  value={item.id_store}
                >
                  <option value={""}>Select Store</option>
                  {storeLoc.map((obj, i) => (
                    <option key={"tag-" + i} value={obj.id}>
                      {obj.store_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="for-group">
                <label htmlFor="url">URL</label>
                <input
                  disabled={
                    approval_status &&
                    approval_status != "NOT SUBMITTED" &&
                    approval_status != "COMPLETED" &&
                    approval_status != "REJECTED" &&
                    (approval_status != "ONREVISED" ||
                      next_step_nik_detail != userInfo.nik)
                  }
                  id="url"
                  name="url"
                  className="form-control"
                  onChange={(e) => onEcoChangeText(e, index)}
                  value={item.url}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label htmlFor="price">Price</label>
                <input
                  disabled={
                    approval_status &&
                    approval_status != "NOT SUBMITTED" &&
                    approval_status != "COMPLETED" &&
                    approval_status != "REJECTED" &&
                    (approval_status != "ONREVISED" ||
                      next_step_nik_detail != userInfo.nik)
                  }
                  id="price"
                  name="price"
                  className="form-control"
                  onChange={(e) => onEcoChangeText(e, index)}
                  value={item.price}
                />
              </div>
            </div>
            <div className="col-md-1">
              <div className="form-group">
                <label htmlFor="price">Action</label>
                <div className="form-group">
                  {(!approval_status ||
                    approval_status == "NOT SUBMITTED" ||
                    approval_status == "COMPLETED" ||
                    approval_status == "REJECTED" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail == userInfo.nik)) && (
                    <a
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeRowEcom(index, item.id)}
                    >
                      <i className="fa fa-trash"></i>{" "}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      {productDetail?.language_code &&
        (!approval_status ||
          approval_status == "NOT SUBMITTED" ||
          approval_status == "COMPLETED" ||
          approval_status == "REJECTED" ||
          (approval_status == "ONREVISED" &&
            next_step_nik_detail == userInfo.nik)) && (
          <div className="row" style={{ margin: "10px" }}>
            <div className="col-md-3">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => addRowEcom(productEcom.length)}
              >
                {" "}
                + Add Ecommerce Product{" "}
              </p>
            </div>
          </div>
        )}
    </div>
  );
};

export default ProductEcommerce;
